export const BASE_URL = 'https://chat1056.papergo.io/api/v1/';
export const SIGNAL_R_URL = "https://chat1056.papergo.io/hubs/v1/chat";
export const MINIMUM_NUMBER_OF_AGENTS_TO_DECLARE_WAITING = 3;
